import { useId } from 'react';

export const MicrosoftTeamsIcon = ({ className }: { className?: string }) => {
  const gradientId = useId() + '-teams-gradient';

  return (
    <svg
      className={className}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#3949ab"
        d="M23.25,20h12.5c3.452,0,6.25,2.798,6.25,6.25v10.5c0,3.452-2.798,6.25-6.25,6.25c-3.452,0-6.25-2.798-6.25-6.25v-10.5C29.5,22.798,26.702,20,23.25,20z"
      />
      <path
        fill="#8c9eff"
        d="M8.561,24.25c0-3.452,2.798-6.25,6.25-6.25h8.439c3.452,0,6.25,2.798,6.25,6.25v12.5c0,3.452,2.798,6.25,6.25,6.25l-16.772,0c-5.753,0-10.417-4.664-10.417-10.417V24.25z"
      />
      <path
        fill="#3949ab"
        d="M34.526,17.737c2.907,0,5.263-2.356,5.263-5.263s-2.356-5.263-5.263-5.263s-5.263,2.356-5.263,5.263S31.619,17.737,34.526,17.737z"
      />
      <path
        fill="#8c9eff"
        d="M18.737,15.632c3.488,0,6.316-2.828,6.316-6.316C25.053,5.828,22.225,3,18.737,3s-6.316,2.828-6.316,6.316C12.421,12.804,15.249,15.632,18.737,15.632z"
      />
      <linearGradient
        id={gradientId}
        x1="-470.78"
        x2="-469.845"
        y1="91.609"
        y2="91.609"
        gradientTransform="matrix(16 16 16 -16 6071.758 9022.23)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="#5961c3" />
        <stop offset="1" stopColor="#3a41ac" />
      </linearGradient>
      <path
        fill={`url(#${gradientId})`}
        d="M7.5,23h10c1.933,0,3.5,1.567,3.5,3.5v10c0,1.933-1.567,3.5-3.5,3.5h-10C5.567,40,4,38.433,4,36.5v-10C4,24.567,5.567,23,7.5,23z"
      />
      <path
        fill="#fff"
        d="M16.219,28.424h-2.588v7.933h-2.184v-7.933H8.86v-1.782h7.36V28.424z"
      />
    </svg>
  );
};
